import { render, staticRenderFns } from "./DemoDropdownBox.vue?vue&type=template&id=f578e94a&"
import script from "./DemoDropdownBox.vue?vue&type=script&lang=js&"
export * from "./DemoDropdownBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports